import React from "react";
import { gql, useMutation } from "@apollo/client";
import {  FieldBtnDanger } from "../dues.style";
import { toaster } from "evergreen-ui";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

// GraphQL mutation for stopping a due
const DUE_STOP_MUTATION = gql`
  mutation Due_stop($dueId: ID!) {
    due_stop(dueId: $dueId) {
      code
      success
      error
      data {
        _id
        facility
        properties
        title
        description
        defaultAmount
        paymentConfiguration {
          type
          numberOfRooms
          amount
        }
        payerType
        appliesToAllProperties
        startDate
        endDate
        paymentFrequency
        isStarted
        isStopped
        createdAt
        bankAccountId
        id
      }
    }
  }
`;

// Component to stop a due
const StopDueButton = ({ dueId }) => {
const history = useHistory()

  const [dueStop, { loading }] = useMutation(DUE_STOP_MUTATION);

  const handleStopDue = async () => {
    try {
      const response = await dueStop({ variables: { dueId } });
      if (response.data.due_stop.success) {
        toaster.success("Due stopped successfully!");
        history.push(`/dues`)
      } else {
        toaster.danger(`Failed to stop due: ${response.data.due_stop.error}`);
      }
    } catch (err) {
      console.error("Error stopping due:", err);
    }
  };

  return (
    <FieldBtnDanger onClick={handleStopDue} disabled={loading} 
    class="waves-effect waves-light btn-flat ">
        <i class="material-icons left">power_settings_new</i>
        {loading ? "Stopping..." : "Stop Due"}
    </FieldBtnDanger>
  );
};

export default StopDueButton;
